/**
 * Templates Module
 *
 * For distribution build template caching
 */
( function () {
	'use strict';

	angular.module( 'templates', [ ] );
} )( );
